<template>
  <div class="translate">
    <span @click="lang('en')">English</span>
    <!-- <span class="zh" @click="lang('zh-CN')">简体中文</span> -->
    <span @click="lang('zh-HK')">繁体中文</span>
  </div>
</template>

<script>
export default {
  name: "translate",
  methods: {
    lang(name) {
      this.$i18n.locale = name;
      window.localStorage.setItem("language", name);
    }
  }
};
</script>

<style lang="less" scoped>
.pseudo-class {
  content: "";
  display: inline-block;
  height: 12px;
  width: 1px;
  position: absolute;
  top: 2px;
  background: #dddddd;
}
.translate {
  span {
    line-height: 40px;
    font-size: 1.4rem;
    cursor: pointer;
    &:first-child {
      padding-right: 30px;
    }
    &:last-child {
      padding-left: 30px;
    }
    &.zh {
      padding: 0 30px;
      position: relative;
      &:before {
        .pseudo-class;
        left: 0;
      }
      &:after {
        .pseudo-class;
        right: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/translate/index.vue